import defaultSettings from './settings'

const title = defaultSettings.title || '东部新中心项目管理系统'

export default function getPageTitle(pageTitle) {
    if (pageTitle) {
        return `${pageTitle} - ${title}`
    }
    return `${title}`
}